<div (click)="$event.preventDefault(); closeModal();"
    class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-20 gap-4">
    <div class="w-full max-w-screen-md flex flex-row gap-1 justify-center overflow-y-auto" (click)="$event.stopPropagation()">
        <div class="flex min-w-full bg-white p-10 rounded-md text-center shadow-lg">
            <form (ngSubmit)="$event.preventDefault(); save();" #certifiedForm="ngForm"
                class="w-full flex flex-col items-center justify-start gap-4">
                <div class="w-full flex flex-row gap-8 items-center justify-between pb-4 border-b border-gray-200">
                    <h2 class="w-full oswald-font text-xl font-medium text-start whitespace-nowrap text-nside-orange-400">
                        {{ isEdit ? 'Edit Staff Member' : 'Add a Staff Member' }}
                    </h2>
                    <button class="p-1 rounded-full hover:bg-gray-100" (click)="$event.preventDefault(); closeModal();">
                        <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                    </button>
                </div>

                <div class="w-full flex flex-col items-center justify-center gap-3 pb-4 border-b border-gray-200">
                    <!-- Name : dropdown of contacts -->
                    <div class="w-full flex items-start gap-3 text-start">
                        <label class="w-56 shrink-0 pt-2 text-nside-gray-300">Name:</label>
                        <div class="flex-1 min-w-0 flex flex-col">
                            <select name="name" [(ngModel)]="entry.name" required
                                class="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded p-2">
                                <option [ngValue]="undefined" disabled>Select a contact</option>
                                <option *ngFor="let contact of contactsList" [value]="contact.name">{{ contact.name }}</option>
                            </select>
                            <div class="w-full text-start italic text-xs text-red-500" *ngIf="certifiedForm.submitted && !entry.name">This field is required.</div>
                        </div>
                    </div>
                    <div class="w-full flex items-center gap-3 text-start">
                        <label class="w-56 shrink-0 text-nside-gray-300">Position/Location:</label>
                        <input type="text" name="position_location" [(ngModel)]="entry.position_location"
                            class="flex-1 min-w-0 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded p-2" placeholder="Position/Location">
                    </div>
                    <div class="w-full flex items-start gap-3 text-start">
                        <label class="w-56 shrink-0 pt-2 text-nside-gray-300">Types of Certifications Held:</label>
                        <textarea name="certifications_held" [(ngModel)]="entry.certifications_held" rows="2"
                            class="flex-1 min-w-0 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded p-2" placeholder="Types of Certifications Held"></textarea>
                    </div>
                    <!-- Expiration Dates : Flowbite datepicker -->
                    <div class="w-full flex items-center gap-3 text-start">
                        <label class="w-56 shrink-0 text-nside-gray-300">Expiration Dates:</label>
                        <div class="flex-1 min-w-0 relative">
                            <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                                <svg class="w-4 h-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"/>
                                </svg>
                            </div>
                            <input #expirationInput type="text" name="expiration_dates"
                                class="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded ps-10 p-2" placeholder="Select date">
                        </div>
                    </div>
                </div>

                <div class="w-full flex flex-row gap-2 items-center justify-end">
                    <button (click)="$event.preventDefault(); closeModal();"
                        class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font">Close</button>
                    <button type="submit"
                        class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                        [ngClass]="{
                            'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': !isValid,
                            'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': isValid
                        }" [disabled]="!isValid">Save</button>
                </div>
            </form>
        </div>
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>
